import React from 'react';
import { Link } from '@inertiajs/react';
import SalesLayout from '../../../components/SalesLayout.jsx';
import Pagination from '../../../components/Pagination.jsx';

function formatPrice(cents) {
  if (cents == null) return '—';
  return `$${(cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

function statusLabel(deal) {
  if (deal.status === 'voided') return { text: 'Withdrawn', cls: 'bg-gray-100 text-gray-700' };
  if (deal.status === 'redeemed') return { text: 'Redeemed', cls: 'bg-green-50 text-green-700' };
  if (deal.expired) return { text: 'Expired', cls: 'bg-amber-50 text-amber-800' };
  return { text: 'Active', cls: 'bg-indigo-50 text-indigo-700' };
}

export default function SalesDealsIndex({ sales_rep, deals = [], pagination }) {
  return (
    <SalesLayout repName={sales_rep?.name}>
      <div className="max-w-4xl mx-auto p-6 sm:p-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">My deals</h1>
          <p className="mt-1 text-sm text-gray-500">Offers you created. Only you and admins can see these.</p>
        </div>

        {deals.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-gray-200 bg-white p-10 text-center">
            <p className="text-sm text-gray-500">You haven't created any deals yet.</p>
            <Link
              href="/sales/deals/new"
              className="mt-4 inline-flex rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-700 transition"
            >
              Create your first deal
            </Link>
          </div>
        ) : (
          <ul className="space-y-3">
            {deals.map((deal) => {
              const status = statusLabel(deal);
              return (
                <li key={deal.id} className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
                  <div className="flex items-start justify-between gap-4 flex-wrap">
                    <div className="min-w-0">
                      <Link href={`/sales/deals/${deal.id}`} className="text-base font-semibold text-gray-900 hover:text-indigo-700">
                        {deal.name}
                      </Link>
                      <p className="mt-0.5 text-xs text-gray-500">
                        {deal.plan === 'subscription' ? 'Subscription' : 'One-time'} · {deal.facility_type_label} ·{' '}
                        {deal.total_seats} seat{deal.total_seats === 1 ? '' : 's'} · created {deal.created_at}
                      </p>
                    </div>
                    <div className="flex items-center gap-3 shrink-0">
                      <span className="text-sm font-semibold text-gray-900">{formatPrice(deal.price_cents)}</span>
                      <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${status.cls}`}>{status.text}</span>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        )}

        {pagination && (
          <Pagination {...pagination} path="/sales" label="deals" />
        )}
      </div>
    </SalesLayout>
  );
}
